<template>
  <div id="clear-whitelist">
    <div class="breadcrumb">清场白名单</div>
    <div class="search-box">
      <el-select v-model="type" class="white-type" @change="search">
        <el-option label="模拟app" value="1"></el-option>
        <el-option label="中病毒" value="2"></el-option>
        <el-option label="运行在虚拟环境" value="3"></el-option>
      </el-select>
      <el-input
        class="search-input"
        type="text"
        placeholder="请输入手机号"
        v-model="phoneNumber"
        @keyup.enter.native="search"
      ></el-input>
      <el-button type="primary" @click="search">搜索</el-button>
      <el-button class="search-new" type="primary" @click="addNewWhiteList"
        >新增白名单</el-button
      >
    </div>

    <div class="clear-cont">
      <el-table :data="whiteList" style="overflow-x: auto">
        <el-table-column prop="index" label="序号" width="70px">
        </el-table-column>
        <el-table-column prop="phoneNumber" label="手机号" width="125px">
        </el-table-column>
        <el-table-column prop="imei" label="手机imei"> </el-table-column>
        <el-table-column
          prop="phoneModel"
          label="手机型号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="systemVersion"
          label="系统版本"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="root" label="是否root" show-overflow-tooltip>
        </el-table-column>
        <el-table-column inline-template label="图片" show-overflow-tooltip>
          <img
            class="white-img"
            v-if="row.imageUrl"
            @click="showImg(row)"
            :src="row.imageUrl"
          />
        </el-table-column>
        <el-table-column prop="type" label="类型"> </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          v-show="totalCount > 0"
          layout="prev, pager, next, jumper"
          :page-size="pageSize"
          :current-page="pageNum"
          :total="totalCount"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 图片弹框 -->
    <el-dialog
      title="图片查看"
      v-model="dialogVisible"
      :modal-append-to-body="false"
    >
      <div class="dialogcont">
        <img :src="imageUrl" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: "",
      phoneNumber: "",
      totalCount: 0,
      pageSize: 20,
      pageNum: 1,
      dialogVisible: false,
      imageUrl: "",
      whiteList: [],
    };
  },
  mounted() {},
  methods: {
    search() {
      this.whiteList = [];
      if (!this.type) return;

      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v1/whiteList/findForPage",
        body: JSON.stringify({
          type: this.type,
          phoneNumber: this.phoneNumber.trim(),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }),
      }).then((response) => {
        if (response.data.error === 10000 && response.data.data) {
          this.totalCount =
            response.data.data.pageCount > 0
              ? response.data.data.pageCount * this.pageSize
              : 0;
          let whiteList = response.data.data.data;

          if (whiteList && whiteList.length > 0) {
            whiteList.forEach((element, index) => {
              this.whiteList.push({
                index: index + 1,
                phoneNumber: element.phoneNumber,
                imei: element.imei,
                phoneModel: element.phoneModel,
                root: element.root ? "是" : "否",
                systemVersion: element.systemVersion,
                imageUrl: element.imageUrl,
                type:
                  element.type == 1
                    ? "模拟app"
                    : element.type == 2
                    ? "中病毒"
                    : "运行在虚拟环境",
              });
            });
          }
        }
      });
    },
    addNewWhiteList() {
      location.href = "/#/whitelist/newWhiteList";
    },
    showImg(row) {
      this.imageUrl = row.imageUrl;
      this.dialogVisible = true;
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.search();
    },
  },
};
</script>
<style scoped>
.search-box {
  padding: 0 30px;
}

.white-type {
  display: inline-block;
  width: 200px;
}

.search-input {
  display: inline-block;
  width: 300px;
}

.search-new {
  float: right;
}

.clear-cont {
  padding: 20px 30px;
}

.white-img {
  height: 25px;
  margin-top: 7px;
}

.dialogcont {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// clearWhiteList.vue?5b8d159d